import { render, staticRenderFns } from "./outsideClick.vue?vue&type=template&id=5dedd75f&scoped=true"
import script from "./outsideClick.vue?vue&type=script&lang=ts"
export * from "./outsideClick.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dedd75f",
  null
  
)

export default component.exports